/**
 * @generated SignedSource<<3d24970cd3d79dffce444f8a30a65a9e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type BankTransactionGroup = "CUSTOMER_PAYMENTS" | "FINANCING" | "OTHER" | "SALARIES" | "SUPPLIERS" | "TAX_OFFICE" | "TRANSFER" | "%future added value";
export type ForecastCategory = "DEPRECIATION" | "FINANCING" | "INCOME_TAXES" | "OTHER" | "OTHER_OPERATING_INCOME" | "PERSONNEL" | "REVENUE" | "SUPPLIERS" | "%future added value";
export type PlannedItemEffect = "LIQUIDITY_ONLY" | "RESULT_AND_LIQUIDITY" | "RESULT_ONLY" | "%future added value";
export type PlannedItemRhythm = "MONTHLY" | "ONE_TIME" | "QUARTERLY" | "YEARLY" | "%future added value";
export type VatRate = "NONE" | "REDUCED" | "STANDARD" | "%future added value";
export type AddPlannedItemInput = {
  definition: PlannedItemDefinitionInput;
};
export type PlannedItemDefinitionInput = {
  category: ForecastCategory;
  dayOfMonth: number;
  effect: PlannedItemEffect;
  endMonth?: string | null | undefined;
  liquidityGroup?: BankTransactionGroup | null | undefined;
  name: string;
  netAmount: number;
  rhythm: PlannedItemRhythm;
  startMonth: string;
  vatRate: VatRate;
};
export type EditPlannedItemDialogAddMutation$variables = {
  input: AddPlannedItemInput;
};
export type EditPlannedItemDialogAddMutation$data = {
  readonly addPlannedItem: {
    readonly id: string;
  };
};
export type EditPlannedItemDialogAddMutation = {
  response: EditPlannedItemDialogAddMutation$data;
  variables: EditPlannedItemDialogAddMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PlannedItem",
    "kind": "LinkedField",
    "name": "addPlannedItem",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditPlannedItemDialogAddMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditPlannedItemDialogAddMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "dcad7cc6a73cfbd8c1d1932ff260e7e7",
    "id": null,
    "metadata": {},
    "name": "EditPlannedItemDialogAddMutation",
    "operationKind": "mutation",
    "text": "mutation EditPlannedItemDialogAddMutation(\n  $input: AddPlannedItemInput!\n) {\n  addPlannedItem(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "0e1b304382c9cc4ae8cf6318e4e54216";

export default node;
